import { useQuery } from "react-query";

import { makeRequest } from "@/util";
import { FormSubmissionAccess } from "../types";

export default function useFormSubmissionAccess(uid: string) {
  return useQuery("get_form_submission_access-" + uid, async () => {
    try {
      if (!uid) {
        return { all: false, form_ids: [] };
      }

      const res = await makeRequest<FormSubmissionAccess>(
        "get_form_submission_access",
        {
          uid: uid,
        },
      );
      return { all: res.data.all, form_ids: res.data.form_ids };
    } catch {
      return { all: false, form_ids: [] };
    }
  });
}
